<script>
export default {
    props:['name','maxSteps','minSteps'],
    data() {
        return {
            step:1,
            timer:0,
            effect: 'slide'
        };
    },    
    methods:{
        goToStep(step, name)
        {
            if(this.name == name)
            {
                //                clearTimeout(this.timer);
                this.step = step;
                // this.startTimer();
            }
        },
        // startTimer()
        // {    
        //     clearTimeout(this.timer);        
        //     this.timer = setInterval(() => {
        //         this.tick();
        //     }, 5000);
        // },
        // stopTimer()
        // {
        //     clearTimeout(this.timer);
        // },
        tick() 
        {        
            if(this.step == this.maxSteps){
                this.step = 1;                
            }else{
                this.step = this.step + 1;    
            }
        },
        tickDown() 
        {        
            if(this.step == this.minSteps){
                this.step = 6;                
            }else{
                this.step = this.step - 1;    
            }
        }
    },    
    mounted() 
    {
        this.$eventHub.$on('startTimer', function (name) {
            if(this.name == name){
                // this.startTimer();    
            }            
        }.bind(this));

        this.$eventHub.$on('stopTimer', function (name) {
            if(this.name == name){
                // this.stopTimer();    
            }            
        }.bind(this));
    },
};
</script>


// WEBPACK FOOTER //
// resources/js/frontend/components/Slider.vue